var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4998 14.7511C26.3254 14.5763 26.0887 14.4781 25.8418 14.4781C25.5949 14.4781 25.3582 14.5763 25.1838 14.7511L20.6198 19.3057L16.0558 14.7417C15.8814 14.567 15.6447 14.4688 15.3978 14.4688C15.1509 14.4688 14.9142 14.567 14.7398 14.7417C14.3758 15.1057 14.3758 15.6937 14.7398 16.0577L19.3038 20.6217L14.7398 25.1857C14.3758 25.5497 14.3758 26.1377 14.7398 26.5017C15.1038 26.8657 15.6918 26.8657 16.0558 26.5017L20.6198 21.9377L25.1838 26.5017C25.5478 26.8657 26.1358 26.8657 26.4998 26.5017C26.8638 26.1377 26.8638 25.5497 26.4998 25.1857L21.9358 20.6217L26.4998 16.0577C26.8545 15.7031 26.8545 15.1057 26.4998 14.7511Z",
    fill: "#C3CAD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F5F6F7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelButton);
export default __webpack_public_path__ + "static/media/CancelButton.28e9e2bf643c29f4cc01a882c8aa6fb6.svg";
export { ForwardRef as ReactComponent };